/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Deft_Newt_BiteInputs */

const en_bold_deft_newt_bite = /** @type {(inputs: Bold_Deft_Newt_BiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Labels`)
};

const de_bold_deft_newt_bite = /** @type {(inputs: Bold_Deft_Newt_BiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Labels`)
};

/**
* | output |
* | --- |
* | "Labels" |
*
* @param {Bold_Deft_Newt_BiteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bold_deft_newt_bite = /** @type {((inputs?: Bold_Deft_Newt_BiteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Deft_Newt_BiteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bold_deft_newt_bite(inputs)
	return de_bold_deft_newt_bite(inputs)
});